"use strict";
require('../../layouts/web')

$(document).ready(function() {
    $('.product-page').owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: true,
        nav: true,
        navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
        }

    })
})
$(document).ready(function() {
    $('.product-features').owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: true,
        autoplayTimeout: 2000,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 3,
            },
            800: {
                items: 4,
            },

            1000: {
                items: 5,
            }
        }

    })
})
$(document).ready(function() {
    $('.banner-slider').owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 3,
            },
            600: {
                items: 3,
            },
            800: {
                items: 4,
            },

            1000: {
                items: 5,
            },
            1300: {
                items: 6,
            }


        }

    })
})